import React, {useState, useEffect, useRef, useLayoutEffect} from "react";
import ReactGridLayout from "react-grid-layout";
import {generateRandomSentence} from './MoreDetailsOperations';
import {useTickContext} from "@dashboard/contexts/TickContext";
import BidOfferTable from './comp/BidOfferTable';   // Import BidOfferTable component
import PriceRange from './comp/PriceRange';         // Import PriceRange component
import VolumeDetails from './comp/VolumeDetails';   // Import VolumeDetails component
import  '../../css/MoreDetails.css';

const MoreDetailsLayout = (props) => {
    const [rowHeight, setRowHeight] = useState(40); // Default row height
    /*const {itemIndexToShowDetailsOf} = props; // Destructure setLayouts from props*/
    const { setLayouts, instrumentToken,layoutIndex,rowWrapperRef,extraClassName} = props;  // Proper destructuring here
    const layoutMoreDetails = [];
    const tickObject = useTickContext();
    const tick=tickObject.tick;
    const moreDetailsRef = useRef(null);
    const bidOfferTableRef = useRef(null);

    // Initialize values to 0 or empty array on the first load
    const [bids, setBids] = useState([]);
    const [offers, setOffers] = useState([]);
    const [open, setOpen] = useState(0);
    const [low, setLow] = useState(0);
    const [high, setHigh] = useState(0);
    const [close, setClose] = useState(0);
    const [lastPrice, setLastPrice] = useState(0);
    const [volume, setVolume] = useState(0);
    const [avgPrice, setAvgPrice] = useState(0);
    const [lowerCircuit, setLowerCircuit] = useState(0);
    const [upperCircuit, setUpperCircuit] = useState(0);
    const [ltq, setLtq] = useState(0);
    const [ltt, setLtt] = useState('N/A');
    const defaultLevels = Array(5).fill({ price: 0, orders: 0, quantity: 0 });

    useEffect(() => {
        if (tick) {
            setBids(
                (tick.depth?.buy?.map(bid => ({
                    price: bid.price,
                    orders: bid.orders,
                    quantity: bid.quantity
                })) || defaultLevels).slice(0, 5) // Ensure always 5 levels
            );

// Update offers
            setOffers(
                (tick.depth?.sell?.map(offer => ({
                    price: offer.price,
                    orders: offer.orders,
                    quantity: offer.quantity
                })) || defaultLevels).slice(0, 5) // Ensure always 5 levels
            );
            setOpen(tick.openPrice || 0);
            setLow(tick.lowPrice || 0);
            setHigh(tick.highPrice || 0);
            setClose(tick.closePrice || 0);
            setLastPrice(tick.lastTradedPrice || 0);
            setVolume(tick.volumeTradedToday || 0);
            setAvgPrice(tick.averageTradePrice || 0);
            setLowerCircuit(tick.lowPrice || 0);
            setUpperCircuit(tick.highPrice || 0);
            setLtq(tick.totalBuyQuantity || 0);
            setLtt(tick.lastTradedTime || 'N/A');
        }
    }, [tick]);

    for (let i = 0; i < 10; i++) {
        // Define layout properties for each grid item
        layoutMoreDetails.push({
            i: `${i}`, // Unique ID for each grid item
            x: 0, // Initial x position
            y: i, // Initial y position
            w: 4, // Width of the grid item
            h: 2, // Height of the grid item
            isResizable: true, // Allow resizing
            isDraggable: true, // Allow dragging
        });
    }

    return (
        <div className={`tick-data-display ${extraClassName ?? ''}`} ref={moreDetailsRef}>
            {/* Pass bids and offers to BidOfferTable */}
            <BidOfferTable bids={bids} offers={offers} ref={bidOfferTableRef}/>

            {/* Pass open, high, low, close, and lastPrice to PriceRange */}
            <div className="ohlc-section1">
                <div className="ohlc-section2">
                    <div className="ohlc">
                        <div className="ohlc-pair">
                            <div className="label">Open</div>
                            <div className="value">{open}</div>
                        </div>
                        <div className="ohlc-pair">
                            <div className="label">Low</div>
                            <div className="value">{low}</div>
                        </div>
                    </div>
                    <div className="ohlc">
                        <div className="ohlc-pair">
                            <div className="label">Prev. Close</div>
                            <div className="value">{close}</div>
                        </div>
                        <div className="ohlc-pair">
                            <div className="label">High</div>
                            <div className="value">{high}</div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Pass volume, avgPrice, and other details to VolumeDetails */}
            <VolumeDetails
                volume={volume}
                avgPrice={avgPrice}
                lowerCircuit={lowerCircuit}
                upperCircuit={upperCircuit}
                ltq={ltq}
                ltt={ltt}
            />
            <div className="amount-cr-parent">
                <div className="amount-cr">
                    <div className="amount-label">Amount Traded in crores</div>
                    <div className="amount-value">
                        {
                            (avgPrice !== null && volume !== null) ?
                                ((Number(avgPrice) * Number(volume)) / 10000000).toFixed(2) :  // Convert to crores and format to 2 decimal places
                                "N/A"
                        }<span> Cr</span>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default MoreDetailsLayout;